<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="90px" inline size="mini">
      <el-form-item label="角色名称">
        <el-input v-model="query.loginName" clearable placeholder="请输入角色名称"></el-input>
      </el-form-item>
      <!-- <el-button class="resetBtn" type="warning" size="mini" @click="custody">重置</el-button> -->
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
      <!-- <el-button class="reloadBtn" type="warning" size="mini" @click="reload">刷新资源</el-button> -->
      <el-button class="addBtn" type="danger" size="mini" @click="addDialogVisible = true">添加角色</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 表格数据展示区域 -->
      <el-table :data="roleList" style="width: 100%" height="650px" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="name" label="角色名称" width="200"></el-table-column>
        <el-table-column prop="description" label="角色描述"></el-table-column>
        <el-table-column label="是否系统角色" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isSystem === 1">是</el-tag>
            <el-tag type="warning" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button type="success" size="small" @click="set(scope.row)">资源分配</el-button>
            <el-button :disabled="scope.row.isSystem === 1" type="primary" size="small" @click="update(scope.row)">修改</el-button>
            <el-button :disabled="scope.row.isSystem === 1" type="danger" size="small" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 添加角色对话框 -->
    <el-dialog title="添加角色" :visible.sync="addDialogVisible" @close="close('addFormRef')" width="35%">
      <el-form :model="addInfo" :rules="addRules" ref="addFormRef" label-width="100px" label-position="left" >
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="addInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="description">
          <el-input v-model="addInfo.description"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="insertRole">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改角色对话框 -->
    <el-dialog title="修改角色" :visible.sync="updateDialogVisible" width="35%">
      <el-form :model="updateInfo" :rules="updateRules" ref="updateFormRef" label-width="100px" label-position="left" >
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="updateInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="description">
          <el-input v-model="updateInfo.description"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateRole">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 配置资源对话框 -->
    <el-dialog title="配置资源" :visible.sync="setPermissionDialogVisible" width="35%">
      <div style="width: 100%; height:600px; overflow-y:auto">
        <el-tree ref="tree" :data="permissionList" show-checkbox default-expand-all
          node-key="uuid" :props="props" :default-checked-keys="defaultCheckedKeys" >
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setPermissionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setPermission">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { roleQuery, roleInsert, roleUpdate, roleDelete, rolePermissionBinding, rolePermissionList } from '@/API/authority'
export default {
  name: 'sysRole',
  data() {
    return {
      query: {
        curPage: 1,
        pageSize: 10,
        name: ''
      },
      // 用户列表
      roleList: [],
      permissionList: [],
      // 数据总条数
      total: 0,
      addDialogVisible: false,
      addInfo: {
        name: '',
        description: ''
      },
      addRules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入角色描述', trigger: 'blur' }]
      },
      updateDialogVisible: false,
      updateInfo: {
        uuid: '',
        name: '',
        description: ''
      },
      updateRules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入角色描述', trigger: 'blur' }]
      },
      setPermissionDialogVisible: false,
      setInfo: {
        roleUuid: '',
        permissionUuids: []
      },
      props: {
        label: 'name',
        children: 'children',
        disabled: function(data, node) {
          return data.disabled === 1
        }
      },
      defaultCheckedKeys: []
    }
  },
  created() {
    this.queryRoleList()
  },
  methods: {
    async queryRoleList() {
      const { data: res } = await roleQuery(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.roleList = res.data.entities
      this.total = res.data.totalSize
    },
    // 重置按钮点击事件
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.queryRoleList()
    },
    // 搜索按钮点击事件
    seach() {
      this.query.curPage = 1
      this.queryRoleList()
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.queryRoleList()
    },
    // 监听curPage
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.queryRoleList()
    },
    reload() {

    },
    insertRole() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await roleInsert(this.addInfo)
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.$refs.addFormRef.resetFields()
        this.queryRoleList()
        this.addDialogVisible = false
      })
    },
    update(row) {
      this.updateDialogVisible = true
      this.updateInfo.uuid = row.uuid
      this.updateInfo.name = row.name
      this.updateInfo.description = row.description
    },
    updateRole() {
      this.$refs.updateFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await roleUpdate(this.updateInfo)
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.$refs.updateFormRef.resetFields()
        this.queryRoleList()
        this.updateDialogVisible = false
      })
    },
    del(row) {
      this.$confirm('是否删除此资源', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await roleDelete({
          uuid: row.uuid
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.queryRoleList()
      })
    },
    async set(row) {
      const { data: res } = await rolePermissionList({ roleUuid: row.uuid })
      if (res.code !== 200) return this.$message.error(res.message)
      this.setInfo.roleUuid = row.uuid
      this.permissionList = res.data
      this.defaultCheckedKeys = []
      for (let i in this.permissionList) {
        let permission = this.permissionList[i]
        if (permission.children.length > 0) {
          this.setDefaultCheckedKeys(permission.children)
        } else {
          if (permission.owner === 1) {
            this.defaultCheckedKeys.push(permission.uuid)
          }
        }
      }
      this.setPermissionDialogVisible = true
    },
    setDefaultCheckedKeys(children) {
      for (let i in children) {
        let permission = children[i]
        if (permission.children.length > 0) {
          this.setDefaultCheckedKeys(permission.children)
        } else {
          if (permission.owner === 1) {
            this.defaultCheckedKeys.push(permission.uuid)
          }
        }
      }
    },
    setPermission() {
      this.setInfo.permissionUuids = []
      let ck1 = this.$refs.tree.getCheckedKeys()
      let ck2 = this.$refs.tree.getHalfCheckedKeys()
      if (ck1.length === 0) {
        this.$message.error('请选择资源')
      }
      this.setInfo.permissionUuids = this.setInfo.permissionUuids.concat(ck1)
      this.setInfo.permissionUuids = this.setInfo.permissionUuids.concat(ck2)
      this.$confirm('是否确认配置权限', '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      ).then(async () => {
        const { data: res } = await rolePermissionBinding(this.setInfo)
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.setPermissionDialogVisible = false
      })
    },
    close(formRef) {
      this.$refs[formRef].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.resetBtn {
  margin-left: 50px;
}
.reloadBtn {
  float: right;
  margin-right: 50px;
}
</style>
